<template>
        <header class="headBox" :class="{scroll:isScroll}">
            <div class="headRelative" @mouseenter="changeNavBg(true)" @mouseleave="changeNavBg(false)" :class="{active:inNav}">
                <div class="logo">
                    <router-link to="/">
						<img v-if="logoUrl" :src="`${$root.$TEMP_URL}${logoUrl}`" />
					</router-link>
                </div>
                <nav class="nav_box" :class="{ active: isnavActive }">
                    <ul>
                        <li>
                            <router-link  @click.native="isnavActive = false" to="/">{{isZhong? '首页' : 'HOME' }}</router-link>
                        </li>
                        <li>
                            <router-link  @click.native="isnavActive = false" to="/about">{{isZhong? '关于我们' : 'ABOUT' }}</router-link>
                            <div class="second_box">
                                <div class="box_l">
                                    <div class="box_l_item"><router-link  @click.native="isnavActive = false" to="/about/profile">{{isZhong?'公司介绍':'Company Profile'}}</router-link></div>
                                    <div class="box_l_item"><router-link  @click.native="isnavActive = false" to="/about/culture">{{isZhong?'公司文化':'Company Culture'}}</router-link></div>
                                    <div class="box_l_item"><router-link  @click.native="isnavActive = false" to="/about/honor">{{isZhong?'公司荣誉':'Company Honor'}}</router-link></div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <router-link  @click.native="isnavActive = false"  to="/products">{{isZhong?'产品':'PRODUCTS'}}</router-link>
                            <div class="second_box">
                                <div class="box_l">
                                    <div class="box_l_item" v-for="item in productNav" :key="item.id"><router-link  @click.native="isnavActive = false" :to='`/products/productlist/${item.id}`'>{{item.name}}</router-link></div>
                                    
                                </div>
                            </div>
                        </li>
                        <li>
                            <router-link  @click.native="isnavActive = false" to="/news">{{isZhong?'新闻':'NEWS'}}</router-link>
                        </li>
                        <li>
                            <router-link  @click.native="isnavActive = false" to="/contact">{{isZhong?'联系我们':'CONTACT'}}</router-link>
                        </li>

                        <div class="searLangua">
                            <router-link @click.native="isnavActive = false"  class="searchBox fa fa-search" to="/search"></router-link>
                            | 
                            <a @click="changeLanguage('zhong')">中文</a> | 
                            <a @click="changeLanguage('ying')">English</a>
                        </div>
                    </ul>
                    
                    
                </nav>
                <nav class="navMobile_box">
                    <i class="fa fa-bars" @click="isnavActive = !isnavActive"></i>
                </nav>
                <div class="header_tools">
                    <ul>
                        <li class="search">
                            <router-link  class="fa fa-search" to="/search"></router-link>
                        </li>
                        <li  class="quick_a">
                            <a href="#">LANGUAGE <img src="./images/language_def.png" /></a>
                            <div class="languageBox">
                                <a @click="changeLanguage('zhong')">中文</a>
                                <a @click="changeLanguage('ying')">English</a>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </header>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
	
import { getLogo,getProductNav,getProductNavcn } from '../../api'
import bus from '../../../static/js/eventBus'
export default {
    data(){
        return{
            inNav:false,
            logoUrl:'',
            productNav:[],
			isZhong:false,
            isnavActive:false,
            isScroll:false
        }
    },
    methods:{
        //改变导航背景
        changeNavBg(status){
            this.inNav = status   
        },
        giveOutData(){
            //把产品分类分发出去
            const  productNav = this.productNav;
            bus.$emit('productNav',{productNav});
        },
		changeLanguage(lg){
            this.isnavActive = false;
			this.$cookies.set('language',lg);
			// this.$router.replace('/')
			this.$router.push('/');
			location.reload();
		},
		async setLanguage(){
			const language = this.$cookies.get('language');
            let res2;

			if(language==="zhong"){
				this.isZhong = true;
                res2 = await getProductNavcn();
			}else{
				this.isZhong = false;
                res2 = await getProductNav();
			}
            const productNav = res2.data.map(v=>{
                return{
                    name:v.name,
                    id:v.scode,
                    ico:v.ico,
                    isActive:false
                } 
            })
            this.productNav=productNav;
		},
        handleHeadScroll(){
            const top = document.documentElement.scrollTop;
            // console.log(top);
            if(top > 60){
                this.isScroll = true;
            }else{
                this.isScroll = false;

            }
         },
    },
    async created(){
        //更新logo
        const res = await getLogo();
        const logoUrl = res.data;
        this.logoUrl = logoUrl;

        this.giveOutData();
        this.setLanguage();
        
    },
    mounted(){
        window.addEventListener('scroll',this.handleHeadScroll);
    }
};
</script>

<style lang="scss" scoped>
@import '../../common/css/mixin.scss';
.headBox{
    width: 96%;
    position: fixed;
    top: 20px;
    left: 2%;
    background: #fff;
    z-index: 99;
    height: 90px;
    transition: top .8s ease;
    -webkit-transition: top .8s ease;
    .headRelative{
        position: relative;
        height: 90px;
        @include flexFather;
        @include compatible(transition,all 0.8s);
        .logo{
            width: 14%;
            position: relative;
            text-align: center;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            @include boxSizing;
            border-right: 1px solid #d9d9d9;
            a{
              img{
                  width: 118px;
                  height: 60px;
                  display: inline-block;
              }
            }
        }
        .nav_box{
            width: 69%;
            ul {
                width: 88%;
                margin: 0 auto;
                li {
                    float: left;
                    width: 20%;
                    text-align: center;
                    font-size: 16px;
                    color: #333;
                    height: 90px;
                    line-height: 90px;
                    >a{
                        display: block;
                    }
                    .second_box{
                        position: absolute;
                        top: 100%;
                        left: 0;
                        width: 100%;
                        background: #fff;
                        box-shadow: 0 2px 5px rgba(0,0,0,0.075);
                        overflow: hidden;
                        @include boxSizing;
                        @include compatible(transition,all 0.5s);
                        // padding: 25px 0 33px;
                        // height: 150px;
                        height: 0;
                        .box_l {
                            width: 65%;
                            float: left;
                            padding-left: 14%;
                            text-align: center;
                            opacity: 0;
                            filter: alpha(opacity=0);
                            transform: translateY(38px);
                            transition: all .5s cubic-bezier(.4,.5,.58,1.11);
                            transition-delay: 0.3s;
                            .box_l_item{
                                width: 20%;
                                float: left;
                                line-height: 30px;
                                font-size: 14px;
                                margin-top: 11px;
                                color: #000;
                                position: relative;
                                text-align: left;
                                margin-bottom: 35px;
                                &::before {
                                    content: '';
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 30px;
                                    height: 1px;
                                    background: #000;
                                    transition: all .5s ease;
                                    -webkit-transition: all .5s ease;
                                }
                                a {
                                    padding-top: 15px;
                                    display: block;
                                }
                                &:hover{
                                    &::before {
                                        content: '';
                                        width: 122px;
                                    }

                                }
                            }
                        }
                    }
                    //li:hover
                    &:hover{
                        .second_box{
                            height: 150px;
                            padding: 25px 0 33px;

                            .box_l{
                               transform: translateY(20px);
                               opacity: 1;
                               filter: alpha(opacity=100);
                            }
                        }
                    }
                }

            }
            &.active{
               display: block;
            }
        }
        .header_tools {
            width: 17%;
            background: $themeColor;
            position: relative;
            ul {
                display: flex;
                align-items: center;
                li{
                    height: 90px;
                    line-height: 90px;
                    width: 30%;
                    &.search{
                        position: relative;
                        .fa{
                            color: #fff;
                            font-size: 22px;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        &::after{
                            content: "";
                            position: absolute;
                            right: 0;
                            top: 50%;
                            margin-top: -15px;
                            width: 1px;
                            height: 30px;
                            background: #fff;
                        }
                    }
                    &.quick_a {
                        width: 70%;
                        font-size: 14px;
                        border-right: none;
                        text-align: right;
                        a {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            color: #fff;
                            img{
                                display: inline-block;
                                margin-left: 10px;
                            }
                        }
                        .languageBox{
                                position: absolute;
                                top: 100%;
                                left: 0;
                                width: 100%;
                                background-color: $themeColor;
                                text-align: left;
                                font-size: 16px;
                                overflow: hidden;
                                // padding: 25px 0 35px;
                                padding: 0;
                                height: 0;
                                @include compatible(transition,all 0.5s);
                                @include boxSizing;
                                a{
									cursor: pointer;
                                    padding-left: 30px;
                                    display: block;
                                    height: 50px;
                                    line-height: 50px;
                                    filter: alpha(opacity=0);
                                    transform: translateX(50px);
                                    transition: all .6s ease-in-out;
                                    -webkit-transition: all .6s ease-in-out;
                                    color: #fff;
                                    position: relative;
                                    transition-delay: 0.2s;

                                    &::before{
                                        content: "";
                                        position: absolute;
                                        left: 0;
                                        top: 50%;
                                        margin-top: -10px;
                                        width: 2px;
                                        height: 20px;
                                        background: #fff;

                                    }
                                    &:last-child{
                                        transition-delay: 0.3s;
                                    }
                                }

                        }
                        //hover
                        &:hover{
                            .languageBox{
                                opacity: 1;
                                padding: 25px 0 35px;
                                height: 160px;
                                a{
                                    transform: translateX(20px);
                                }
                            }
                        }
                    }
             
                }
            }
        }
        &.active{
            background: #0d69af;
            .nav_box{
                ul{
                    li{
                        >a{
                            color: #fff;
                        }
                       
                    }
                }
            }
        }
    }
    &.scroll{
        top:0px;
        -moz-box-shadow: 2px 3px 9px #f2f2f2;
        -webkit-box-shadow: 2px 3px 9px #f2f2f2;
        box-shadow: 2px 3px 9px #f2f2f2;
        -ms-filter: "progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color='#f2f2f2')";
        filter: progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color="#f2f2f2");
    }
}
.navMobile_box{
    display: none;
}
.searLangua{
    display: none;
}


@media screen and (max-width: 1399px) {
    .headBox{
        width: 97%;
        left: 1.5%;
    }
}

@media screen and (max-width: 1199px) {
    .headBox{
        position: initial;
        width: 100%;
    }
    .headBox .headRelative .nav_box{
        display: none;
        position: absolute;
        top: 90px;
        z-index: 999;
        background: rgba(36, 36, 36,0.9);
        width: 100%;


    }
    .navMobile_box{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex: 1;
        height: 100%;
        i{
            display: block;
            font-size: 24px;
            font-weight: bold;
            height: 90px;
            line-height: 90px;
            width: 90px;
            text-align: center;
            cursor: pointer;
            &:hover{
                background: #fff;
            }
        }
    }
   
    .headBox .headRelative .header_tools{
        width: 27%;
        display: none;
    }
    .headBox .headRelative .logo{
        width: 20%;
    }
    .headBox .headRelative .nav_box ul li>a {
        color: #fff;
    }
    .headBox .headRelative .nav_box ul li {
        height: auto;
        line-height: 32px;
        width: 100%;
        text-align: left;
        float: none;
        &:hover{
            .second_box{
                height: auto;
                padding: 0;
                .box_l{
                    transform: translateY(0);
                }
            }
        }
    }
    .headBox .headRelative .nav_box ul{
        padding: 32px 0;
    }
    .headBox .headRelative .nav_box ul li .second_box{
        position: initial;
        background: none;
        height: auto;
    }
    .headBox .headRelative .nav_box ul li .second_box .box_l {
        width: 100%;
        float: none;
        padding-left: 0;
        text-align: center;
        opacity: 1;
        transform: translateY(0);
    }
    .headBox .headRelative .nav_box ul li .second_box .box_l .box_l_item a{
        color: #fff;
            padding-top: 0;
    }
    .headBox .headRelative .nav_box ul li .second_box .box_l .box_l_item {
        width: 100%;
        float: none;
        line-height: 24px;
        margin-top: 0;
        margin-bottom: 0;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        border-top: 1px solid #b8b8b8;
        background: #6a6a6a;
        text-align: left;
        padding-left: 18px;
    }
    .searLangua{
        display: block;
        color: #fff;
        margin-top: 12px;
    }
    .searLangua .searchBox,.searLangua a{
        color: #fff;
        font-size: 16px;
        height: 100%;
        display: inline-block;
        padding: 0 8px;
        cursor: pointer;
    }



}



</style>


// WEBPACK FOOTER //
// src/components/Header/Header.vue